/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./ServiceMore.css";
import { FiArrowRight, FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function ServiceMore() {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* ===================== SERVICES CTA ===================== */}
      <section className="service-more-section">
        <div className="service-more-inner">
          <Link
            to="/services"
            className="service-more-btn"
            style={{ textDecoration: "none" }}
            onClick={handleLinkClick}
          >
            See More Services
            <FiArrowRight className="service-more-arrow" />
          </Link>
        </div>
      </section>

      {/* ===================== MAIN CTA ===================== */}
      <section className="FaclityTransform">
        <section className="facility-cta-section">
          <div className="facility-cta-inner">
            <h2>Ready to Transform Your Facility?</h2>
            <p>
              Get a free site assessment and discover how we can help maintain
              world-class environments.
            </p>

            <div className="facility-cta-buttons">
              {/* CONTACT PAGE */}
              <a
                href="/Contact"
                className="facility-cta-btn cta-primary"
                style={{ textDecoration: "none" }}
              >
                Request a Free Site Assessment
              </a>

              {/* CLICK TO CALL */}
              <a
                href="tel:+919899811123"
                className="facility-cta-btn cta-secondary"
                style={{ textDecoration: "none" }}
              >
                <FiPhoneCall className="cta-call-icon" />
                Call Now for a Tailored Quote
              </a>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
